/**
 * v2-popup.js — Newsletter popup, vanilla replacement for the old
 * jQuery + Fancybox implementation (z__jsPopup.js).
 *
 * Uses the native <dialog> element: free backdrop, ESC-to-close, focus
 * trap and top-layer stacking — no library required. Reads its config
 * from the inline [data-popup-config] JSON the section renders.
 *
 * Behaviour mirrors the original:
 *   - waits `popup_delay` seconds, then opens
 *   - sets a `popup` cookie for `popup_days_to_hide` days (0 = test mode,
 *     always shows and never sets the cookie)
 *   - always opens in the theme editor (Shopify.designMode)
 */
(function () {
  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (acc, pair) {
      var parts = pair.split('=');
      return parts[0] === name ? decodeURIComponent(parts.slice(1).join('=')) : acc;
    }, '');
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function initPopup(section) {
    var dialog = section.querySelector('dialog.v2-popup');
    if (!dialog || dialog.dataset.inited) return;
    dialog.dataset.inited = '1';

    var config = {};
    try {
      config = JSON.parse(section.querySelector('[data-popup-config]').textContent);
    } catch (e) { /* keep defaults */ }

    var delayMs = (parseFloat(config.popup_delay) || 0) * 1000;
    var daysToHide = parseInt(config.popup_days_to_hide, 10) || 0; // 0 = test mode
    var cookieActive = daysToHide !== 0;
    var inEditor = window.Shopify && window.Shopify.designMode;

    function lockScroll(locked) {
      document.documentElement.style.overflow = locked ? 'hidden' : '';
    }
    function open() {
      if (dialog.open) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', ''); // very old browser fallback
      lockScroll(true);
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      lockScroll(false);
    }

    // Close affordances: custom button, backdrop click, native ESC (cancel).
    var closeBtn = dialog.querySelector('.popup__close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('click', function (e) {
      // A click whose target is the dialog itself is a click on the backdrop;
      // clicks on the inner content bubble from child elements.
      if (e.target === dialog) close();
    });
    dialog.addEventListener('cancel', function () { lockScroll(false); });
    dialog.addEventListener('close', function () { lockScroll(false); });

    // Theme editor: always show, ignore cookie/delay.
    if (inEditor) { open(); return; }

    if (cookieActive && getCookie('popup') === 'opened') return;

    window.setTimeout(function () {
      open();
      if (cookieActive) setCookie('popup', 'opened', daysToHide);
    }, delayMs);
  }

  function boot() {
    document.querySelectorAll('.v2-popup-section').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-inits when the section is added/changed.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector('.v2-popup-section')
      : null;
    if (e.target.classList && e.target.classList.contains('v2-popup-section')) {
      section = e.target;
    }
    if (section) initPopup(section);
  });
})();
